import posthtml from 'posthtml/lib';
import { getMjHeadElementsForFonts } from './get-mj-elements-for-fonts';
export const addFontsToHead = (mjml, customFonts, customFontsEnabled) => {
  const {
    mjFontElements,
    mjStyleElement
  } = getMjHeadElementsForFonts(mjml, customFonts, customFontsEnabled);
  const appendFonts = tree => {
    tree.match({
      tag: 'mj-head'
    }, node => {
      if (!node.content) {
        node.content = [];
      }
      mjFontElements.forEach(element => node.content.push(element));
      if (mjStyleElement) {
        node.content.push(mjStyleElement);
      }
      return node;
    });
    return tree;
  };
  const withFonts = posthtml([appendFonts]).process(mjml, {
    sync: true,
    xmlMode: true
  });
  return withFonts.html;
};
//# sourceMappingURL=add-fonts-to-head.js.map